import type { RouterConfig } from '@nuxt/schema';

export default {
  scrollBehavior(to, from, savedPosition) {
    // disable default scroll for anchor links, it is handled in useAnchorTag composable
    if (to.hash) {
      return false;
    }
    return savedPosition || { left: 0, top: 0 };
  },
} satisfies RouterConfig;
